module.exports = __webpack_public_path__ + "static/media/AB_shadow_angel.86a85fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_shadow_angel.png
// module id = 545
// module chunks = 0